import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoginModal from './LoginModal';
import PublicProfile from './PublicProfile';
import ProfileModal from './ProfileModal';

const ProtectedRoute = ({ children }) => {
  const { user, loading, emailLinkProfileId, clearEmailLinkProfileId, isNewUser, setIsNewUser } = useAuth();
  const [showLoginModal, setShowLoginModal] = React.useState(false);
  const [showProfileModal, setShowProfileModal] = React.useState(false);

  React.useEffect(() => {
    if (!loading && !user) {
      setShowLoginModal(true);
    } else {
      setShowLoginModal(false);
    }
  }, [user, loading]);

  // Handle new user profile setup
  React.useEffect(() => {
    if (user && isNewUser) {
      console.log('New user detected in ProtectedRoute, showing profile modal');
      setShowProfileModal(true);
    }
  }, [user, isNewUser]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 mx-auto mb-4" style={{borderColor: 'var(--brand-navy)'}}></div>
          <div className="text-lg" style={{color: 'var(--brand-navy)'}}>Loading...</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <>
        <LoginModal 
          isOpen={showLoginModal} 
          onClose={() => setShowLoginModal(false)} 
        />
        
        {/* Email Link Profile Modal for Unauthenticated Users */}
        {emailLinkProfileId && (
          <PublicProfile
            userId={emailLinkProfileId}
            isModal={true}
            onClose={() => clearEmailLinkProfileId()}
          />
        )}
        
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center">
          {/* Clean background - login modal will be automatically centered */}
        </div>
      </>
    );
  }

  return (
    <>
      {children}
      
      {/* Profile Modal for new users */}
      <ProfileModal
        isOpen={showProfileModal}
        onClose={() => {
          setShowProfileModal(false);
          setIsNewUser(false);
        }}
      />
    </>
  );
};

export default ProtectedRoute;